<template>
  <div class="container">
    <header class="header">
      <h1>{{ msg }}</h1>
    </header>
   

  </div>
</template>

<script>
import { ethers } from "ethers";

export default {
  name: 'UserWallet',
  props: {
    msg: String
  },
  data() {
    return {
      referAddress: '',
      userAddress: '',
      PLATBalance: '',
      totalSupply: 100000000000000,
      currentTotalSupply: 0,
      remainingClaims: 0,
      rpcAddress: "https://polygon-rpc.com",
      contractAddress: "0x6EC063057eE3D6fE80f913204172762922d507Cc", 
      burned: 0,
      
    }
  },
  methods: {
    async getTokenBalance() {
      const abi = [
        "function totalSupply() external view returns (uint256)",
        "function balanceOf(address account) external view returns (uint256)"
      ];

      const provider = new ethers.providers.JsonRpcProvider(this.rpcAddress);
      const contract = new ethers.Contract(this.contractAddress, abi, provider);

      const balance = await contract.balanceOf(this.userAddress);
      this.PLATBalance = ethers.utils.formatEther(balance);
      },async getContractBalance() {
        const abi = [
        "function totalSupply() external view returns (uint256)",
        "function balanceOf(address account) external view returns (uint256)"
      ];

      const provider = new ethers.providers.JsonRpcProvider(this.rpcAddress);
      const contract = new ethers.Contract(this.contractAddress, abi, provider);

      const balance = await contract.balanceOf(this.contractAddress);
      console.log(balance);

      //this.remainingClaims = ethers.utils.formatEther(balance);
      },
      async getCurrentSupply() {
      const abi = [
        "function totalSupply() external view returns (uint256)",
        "function balanceOf(address account) external view returns (uint256)"
      ];

      const provider = new ethers.providers.JsonRpcProvider(this.rpcAddress);
      const contract = new ethers.Contract(this.contractAddress, abi, provider);

      const balance = await contract.totalSupply();
      console.log("#### "  + ethers.utils.formatEther(balance));
      this.currentTotalSupply = ethers.utils.formatEther(balance);

      this.burned = (100000000000000 - this.currentTotalSupply);

      }
      ,claim_old() {
        if (this.referAddress === '') {
          alert("Insert referral address.");
          return;
        }

        let abi = [{
          "inputs": [
            {
              "internalType": "address",
              "name": "referrer",
              "type": "address"
            }
          ],
          "name": "claim",
          "outputs": [
            {
              "internalType": "bool",
              "name": "success",
              "type": "bool"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        }];

        console.log("userAddress: " + this.userAddress);
        console.log("referAddress: " + this.referAddress);


        this.provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = this.provider.getSigner(this.userAddress);


        const contract = new ethers.Contract(this.contractAddress, abi, this.provider);
        const daiWithSigner = contract.connect(signer);

        console.log("User " + this.referAddress + " claiming...");


        daiWithSigner.claim(this.referAddress)
          .then(ret => {

            alert("Transaction successful! Transaction hash: " + ret.hash);
            console.log('Transaction hash:', ret.hash);
            alert('You can view this transaction on POLYGON Scan at: https://polygonscan.com/tx/' + ret.hash);
          })
          .catch(error => {

            console.error('Error during transaction:', error);
            if (error.reason) {
              console.log('Transaction failed:', error.reason);
            } else {
              console.error('Unknown error:', error);
            }

            alert("Transaction failed! Error message: " + error.reason);
          });
      }
  },
  async beforeMount() {
    /*
    if (window.ethereum) {
      await window.ethereum.request({ method: 'eth_requestAccounts' });
      this.userAddress = (await window.ethereum.request({ method: 'eth_accounts' }))[0];
      this.getTokenBalance();
    } else {
      alert("Please install MetaMask to use this feature!");
    }
    this.getCurrentSupply();
    this.getContractBalance();
    */
  }
}
</script>

<style scoped>
body {
  font-family: 'Roboto', sans-serif;
  background-color: #000000;;
  margin: 0;
  padding: 0;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header h1 {
  color: white;
  font-size: 2.5rem;
  text-align: center;
  margin: 0;
  padding: 0 20px;
  background-color: rgba(0, 0, 0, 0.5); 
  border-radius: 10px;
  
}


header {
  width: 100%;
  height: 400px; 
  background-image: url('../assets/wallpapper_platypus2.gif');
  background-size: cover; 
  background-position: center;
  background-color: rgba(0, 0, 0, 0.8); 
  margin-bottom: 20px;
}

.card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.form__label {
  font-size: 1.2rem;
  margin-bottom: 10px;
  color: #555;
  text-align: center;
}

.info p {
  margin: 5px 0;
  color: #333;
}

.form__input, .form__input_text_big {
  font-size: 1rem;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
  max-width: 400px;
  margin: 10px 0;
  box-sizing: border-box;
}

.form__input2 {
  font-size: 1rem;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
  max-width: 600px;
  margin: 10px 0;
  box-sizing: border-box;
  text-align: center
}

.form__input_text_big {
  font-size: 1.5rem;
}



.btn {
  border: none;
  font-family: 'Lato';
  font-size: inherit;
  color: inherit;
  background: none;
  cursor: pointer;
  padding: 25px 80px;
  display: inline-block;
  margin: 15px 30px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
  outline: none;
  position: relative;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}

.btn:after {
  content: '';
  position: absolute;
  z-index: -1;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}

/* Pseudo elements for icons */
.btn:before {
  font-family: 'FontAwesome';
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  position: relative;
  -webkit-font-smoothing: antialiased;
}


/* Icon separator */
.btn-sep {
  padding: 25px 60px 25px 120px;
}

.btn-sep:before {
  background: rgba(0,0,0,0.15);
}

/* Button 1 */
.btn-1 {
  background: #3498db;
  color: #fff;
}

.btn-1:hover {
  background: #2980b9;
}

.btn-1:active {
  background: #2980b9;
  top: 2px;
}

.btn-1:before {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  line-height: 3;
  font-size: 140%;
  width: 60px;
}

/* Button 2 */
.btn-2 {
  background: #2ecc71;
  color: #fff;
}

.btn-2:hover {
  background: #27ae60;
}

.btn-2:active {
  background: #27ae60;
  top: 2px;
}

.btn-2:before {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  line-height: 3;
  font-size: 140%;
  width: 60px;
}

/* Button 3 */
.btn-3 {
  background: #e74c3c;
  color: #fff;
}

.btn-3:hover {
  background: #c0392b;
}

.btn-3:active {
  background: #c0392b;
  top: 2px;
}

.btn-3:before {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  line-height: 3;
  font-size: 140%;
  width: 60px;
}

/* Button 3 */
.btn-4 {
  background: #34495e;
  color: #fff;
}

.btn-4:hover {
  background: #2c3e50;
}

.btn-4:active {
  background: #2c3e50;
  top: 2px;
}

.btn-4:before {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  line-height: 3;
  font-size: 140%;
  width: 60px;
}

/* Icons */

.icon-cart:before {
  content: "\1F4B0";
  font-size: 24px;
  margin-right: 5px;
}

.icon-heart:before {
  content: "\1F4B0";
  font-size: 24px;
  margin-right: 5px;
}

.icon-info:before {
  content: "\1F4B0";
  font-size: 24px;
  margin-right: 5px;
}

.icon-send:before {
  content: "\1F4B0";
  font-size: 24px;
  margin-right: 5px;
}


</style>